.line {
  display: inline-flex;
  align-items: center;
  flex-wrap: wrap;
  gap: var(--tuna-spacing-2);
}

.available {
  color: var(--tuna-content-secondary);
  font-size: var(--tuna-typography-body2-fontSize);
}

/*
 * The counts the avatars cannot show. Muted rather than coloured: maybe and no are folded
 * into one line here, so a single colour could only mean one of them.
 */
.detail {
  color: var(--tuna-content-muted);
  font-size: var(--tuna-typography-body2-fontSize);
}

.avatars {
  display: inline-flex;
  align-items: center;
  gap: var(--tuna-spacing-1);
  /* Reserved so a date with no yes-voters sits at the same height as one with them. */
  min-height: 24px;
}
